// Simplified relationTo object structure for task data grid view
export interface SimplifiedRelationToData {
  id: string;
  first_name?: string;
  last_name?: string;
  name?: string;
  source_id?: string;
  lifecycle_step?: string;
  resident_id?: string;
  facility_id?: string;
}

export class SimplifiedRelationTo implements SimplifiedRelationToData {
  id: string;
  first_name?: string;
  last_name?: string;
  name?: string;
  source_id?: string;
  lifecycle_step?: string;
  resident_id?: string;
  facility_id?: string;

  constructor(data: SimplifiedRelationToData) {
    this.id = data.id;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.name = data.name;
    this.source_id = data.source_id;
    this.lifecycle_step = data.lifecycle_step;
    this.resident_id = data.resident_id;
    this.facility_id = data.facility_id;
  }

  get fullName(): string {
    if (this.first_name && this.last_name) {
      return `${this.first_name} ${this.last_name}`;
    }
    if (this.name) {
      return this.name;
    }
    if (this.first_name) {
      return this.first_name;
    }
    return 'Unknown';
  }

  get initials(): string {
    if (this.name) {
      const nameParts = this.name.split(' ');
      return nameParts
        .map((part) => part.charAt(0))
        .join('')
        .toUpperCase();
    }
    if (this.first_name && this.last_name) {
      return `${this.first_name.charAt(0)}${this.last_name.charAt(0)}`.toUpperCase();
    }
    if (this.first_name) {
      return this.first_name.charAt(0).toUpperCase();
    }
    return '?';
  }
}
